import { useState } from 'react';
import { Check, UserPlus, X } from 'lucide-react';
import { Button } from '../../ui/button';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import { AdminTag } from './TeamTab';

export const RecruiterPicker = ({ team, userIds, onChange }) => {
    const [open, setOpen] = useState(false);
    const selected = team.filter((u) => userIds.includes(u.id));
    const toggle = (id) => onChange(userIds.includes(id) ? userIds.filter((x) => x !== id) : [...userIds, id]);

    return (
        <div className="flex flex-wrap items-center gap-2" data-testid="assign-recruiter-picker">
            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Assign to</span>
            {selected.map((u) => (
                <span key={u.id} className="inline-flex items-center gap-1.5 rounded-full border border-violet-300 bg-violet-500/10 px-2.5 py-1 text-xs font-medium dark:border-violet-700/60" data-testid={`assign-recruiter-chip-${u.id}`}>
                    {u.name}
                    <button type="button" onClick={() => toggle(u.id)} aria-label={`Remove ${u.name}`} className="rounded-full p-0.5 hover:bg-violet-500/20" data-testid={`assign-recruiter-remove-${u.id}`}>
                        <X className="h-3 w-3" />
                    </button>
                </span>
            ))}
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button size="sm" variant="outline" className="h-7 rounded-full" data-testid="assign-recruiter-add">
                        <UserPlus className="mr-1.5 h-3.5 w-3.5" /> {selected.length ? 'Add recruiter' : 'Choose recruiters'}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-80 p-0" align="start">
                    <Command>
                        <CommandInput placeholder="Search by name, email or department..." data-testid="assign-recruiter-search" />
                        <CommandList>
                            <CommandEmpty>No recruiters found</CommandEmpty>
                            <CommandGroup>
                                {team.map((u) => (
                                    <CommandItem key={u.id} value={`${u.name} ${u.email} ${u.department || ''}`} onSelect={() => toggle(u.id)} data-testid={`assign-recruiter-option-${u.id}`}>
                                        <Check className={`mr-2 h-4 w-4 text-violet-600 ${userIds.includes(u.id) ? 'opacity-100' : 'opacity-0'}`} />
                                        <div className="min-w-0">
                                            <p className="truncate text-sm">{u.name}{u.role === 'admin' && <AdminTag />}</p>
                                            <p className="truncate text-xs text-muted-foreground">{u.department || u.email}</p>
                                        </div>
                                    </CommandItem>
                                ))}
                            </CommandGroup>
                        </CommandList>
                    </Command>
                </PopoverContent>
            </Popover>
        </div>
    );
};
